import React, { useCallback, useEffect, useState } from "react"
// import AddressSelectionMap from "./AddressSelectionMap"
import { Coordinates, Place, SavedAddress } from "../../types/address"
import SearchIcon from "../icons/SearchIcon"
import LocateIcon from "../icons/LocateIcon"
import LocationIcon from "../icons/LocationIcon"
import Skeleton from "react-loading-skeleton"
// import SearchSection from "./SearchSection"
import { fetchPlace, getReverseGeocode } from "../../services/api/address"
// import CompleteAddress from "./CompleteAddress"
import { useDispatch } from "react-redux"
// import { APIProvider } from "@vis.gl/react-google-maps"
// import { GOOGLE_MAPS_API_KEY } from "../../constants/constants"
import { AppDispatch } from "store"
import { fetchInfluencerAddressesThunk } from "slices/addressBook/thunk"
import { useParams } from "react-router-dom"
import AddressList from "./AddressList"

interface AddressBookProps {
    onSelection?: (address: SavedAddress) => void
}
const indiaCenter = {
    latitude: 22.9734, // Latitude
    longitude: 78.6569  // Longitude
};

const AddressBook: React.FC<AddressBookProps> = ({ onSelection }) => {

    // const [addNew, setAddNew] = useState(false);
    // const [coordinates, setCoordinates] = useState<Coordinates | null>(null);

    // const [place, setPlace] = useState<Place | null>(null);

    // const [fetching, setFetching] = useState(true);

    // const [searchSection, setSearchSection] = useState(false);

    // const [confirmLocation, setConfirmLocation] = useState(false);

    // const dispatch: AppDispatch = useDispatch();

    // const {influencerId} = useParams();

    // const fetchAddressBook = useCallback((force = false) => {
    //     if(influencerId)
    //         dispatch(fetchInfluencerAddressesThunk({influencerId}));
    // }, [dispatch, influencerId])

    // const reverseGeocoding = async (coords: Coordinates) => {
    //     try {
    //         setFetching(true);
    //         const result = await getReverseGeocode(coords);
    //         if (Array.isArray(result) && result.length > 0) {
    //             setPlace(result[0]);
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     } finally {
    //         setFetching(false);
    //     }
    // }

    // const fetchGeolocation = async () => {
    //     navigator.geolocation.getCurrentPosition(
    //         (pos) => setCoordinates({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
    //         (err) => {
    //             console.error(err)
    //             setCoordinates(indiaCenter); // Fallback to India center if geolocation fails
    //         }
    //     )
    // }

    // const fetchPlaceData = async (placeId: string) => {
    //     try {
    //         setFetching(true);
    //         const result = await fetchPlace(placeId);
    //         if (result.location) {
    //             setCoordinates(result.location);
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    // useEffect(() => {
    //     if (addNew) {
    //         fetchGeolocation();
    //     }
    // }, [addNew])

    // useEffect(() => {
    //     if (coordinates) {
    //         reverseGeocoding(coordinates)
    //     }
    // }, [coordinates])

    return (
        <div className="address-selection">
            {/* {
                addNew && coordinates ? (
                    searchSection ? (
                        <SearchSection
                            onCancel={() => {
                                setSearchSection(false)
                                fetchGeolocation();
                            }}
                            currentGeolocation={coordinates}
                            onPlaceSelection={(place) => {
                                setSearchSection(false);
                                fetchPlaceData(place.placePrediction.placeId)
                            }}
                        />
                    ) :
                        (
                            <div className="map position-relative">
                                <div className="search-mockup-wrapper">
                                    <div className="search-mock " onClick={() => setSearchSection(true)}>
                                        <span className="search-text">Search a building, street name or area</span>
                                        <SearchIcon />
                                    </div>
                                </div>
                                <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
                                    <AddressSelectionMap
                                        coordinates={coordinates ?? { latitude: 0, longitude: 0 }}
                                        setCoordinates={setCoordinates}
                                    />
                                </APIProvider>
                                <div className="located-address-wrapper">
                                    {
                                        confirmLocation && coordinates ? (
                                            <CompleteAddress
                                                place={place}
                                                coords={coordinates}
                                                onCancel={() => setConfirmLocation(false)}
                                                afterSubmit={() => {
                                                    setAddNew(false)
                                                    fetchAddressBook(true);
                                                }}
                                            />
                                        ) :
                                            (
                                                <React.Fragment>
                                                    <div className="locate-me cursor-pointer" onClick={e => fetchGeolocation()}>
                                                        <LocateIcon />
                                                        <span>Use Current Location</span>
                                                    </div>
                                                    <div className="located-address mt-3">
                                                        <div className="located-address-content pb-0">
                                                            <div className="located-address-content-primary">
                                                                <div className="located-address-content-primary-left">
                                                                    <LocationIcon />
                                                                    {
                                                                        fetching ? <Skeleton height={20} width={100} /> : <span>{place?.address_components[0]?.long_name}</span>
                                                                    }
                                                                </div>
                                                                <button onClick={() => setSearchSection(true)} className="change-location-btn">Change</button>
                                                            </div>
                                                            <div className="located-address-content-secondary">
                                                                {
                                                                    fetching ? <Skeleton /> : <span>{place?.formatted_address}</span>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="confirm-location-wrapper">
                                                            <button onClick={() => setConfirmLocation(true)} className="theme-btn theme-btn-primary w-100">
                                                                Confirm Location
                                                            </button>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )
                                    }

                                </div>
                            </div>
                        )
                ) :
                    (
                        <AddressList
                            onAddNew={() => setAddNew(true)}
                            onSelection={onSelection}
                        />
                    )
            } */}
            <AddressList
                onSelection={onSelection}
            />
        </div>
    )
}

export default AddressBook